import { useContext } from 'react'

import { FeatureFlagContext } from '@/shared/providers/feature-flag/context'

export const useFeatureFlag = () => useContext(FeatureFlagContext)
